module.exports = __webpack_public_path__ + "img/上一页.abde8a6f.png";